/**
 * 两数相加函数
 *
 * @example
 * // 传入两个数值
 * console.log(sum(1,2))
 *
 */
function sum(x: number, y: number): number {
  return x + y
}

export default sum
